import React, { useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import SurveyDetail from "./SurveyDetail";
import PollUsers from "../FeedPoll/PollUsers";
import SurveyUsers from "./SurveyUsers";

export default function FeedSurveyResult(props) {
  const { selectedFeed, handleCloseSurvey, openSurvey } = props;
  const [componentState, setComponentState] = useState(0);
  const [selectedOption, setSelectedOption] = useState({});

  const handleOptionResult = (option) => {
    setSelectedOption(option);
    setComponentState(1);
  };

  const handleBack = (option) => {
    setComponentState((old) => old - 1);
  };

  return (
    <div className="poll-result-modal">
      <div className="d-flex justify-content-between">
        <div>
          {componentState > 0 && (
            <h2 className="cursor-pointer" onClick={handleBack}>
              <ArrowBackIcon />
            </h2>
          )}
        </div>
        <h2 className="text-center">Survey</h2>
        <div>
          <h2 className="cursor-pointer" onClick={handleCloseSurvey}>
            <ClearIcon />
          </h2>
        </div>
      </div>
      <hr className="my-2" />
      <div className="poll-result-card">
        {componentState === 0 ? (
          <SurveyDetail
            selectedFeed={selectedFeed}
            handleOptionResult={handleOptionResult}
          />
        ) : (
          <SurveyUsers
            selectedFeed={selectedFeed}
            selectedOption={selectedOption}
            openPoll={openSurvey}
          />
        )}
      </div>
    </div>
  );
}
